import { FC } from 'react';
import { LazyReferenceInputMultiFilter } from './LazyReferenceInputMultiFilter';

interface UserRoleMultiReferenceInputProps {
  source: string;
  roles: string[];
  label?: string;
  referenceForGetOne?: string;
  alwaysOn?: boolean;
  resettable?: boolean;
  allowEmpty?: boolean;
  'data-cy'?: string;
}

// With a search value, role + fullName must be nested inside `s`: composeQuery
// short-circuits to `search(s)` and drops sibling flat keys, which would otherwise
// return every user regardless of role.
const buildMultipleFilters = (roles: string[]) => (value: string) =>
  roles.map(role =>
    value
      ? {
          s: {
            $and: [
              { roleNames: { $cont: `,${role},` } },
              { fullName: { $contL: value } },
            ],
          },
        }
      : { 'roleNames||$cont': `,${role},` },
  );

export const UserRoleMultiReferenceInput: FC<UserRoleMultiReferenceInputProps> = ({
  roles,
  label = 'Created By',
  ...rest
}) => (
  <LazyReferenceInputMultiFilter
    {...rest}
    label={label}
    reference="user-role-region-list"
    sort={{ field: 'firstName', order: 'ASC' }}
    optionText="fullName"
    optionValue="id"
    multipleFilters={buildMultipleFilters(roles)}
  />
);
